import React from 'react';

// Components
import * as S from './Styled';
import { Form, Success } from './index';

// Store
import { useSelector } from 'react-redux';
import Spinner from '../../Spinner';

const ForgotPassword = ({ onOk, visible }) => {
  const authState = useSelector(state => state.auth);
  const { isLoading } = authState;

  return (
    <S.Login>
      {isLoading ? (
        <S.SpinnerCase>
          <Spinner size="small" flow="block" />
        </S.SpinnerCase>
      ) : authState.data !== null && authState.data.message ? (
        <Success />
      ) : (
        <Form onOk={onOk} visible={visible} />
      )}
    </S.Login>
  );
};

export default ForgotPassword;
